import React from 'react'
import { Button, CoachMark, NewBadge } from '@buffer-mono/popcorn'
import { useSplitEnabled } from '@buffer-mono/features'
import useDismissBanner, {
  BannerTypes,
} from '../../../../common/hooks/useDismissBanner'

/**
 * Coach mark component that highlights the "Templates" feature
 * on the "Create" navigation tab until followed or dismissed.
 */
export const TemplatesCoachMark = ({
  onClick,
  children,
}: {
  onClick: () => void
  children: React.ReactNode
}): JSX.Element => {
  const { isEnabled: isAnnouncementSplitEnabled } = useSplitEnabled(
    'templates_announcement',
  )
  const { isActive: isBannerActive, onDismissBanner } = useDismissBanner({
    banner: BannerTypes.templatesCoachMark,
  })

  // Show coach mark when the banner is active and the announcement split is enabled
  const shouldShowCoachMark = isAnnouncementSplitEnabled && isBannerActive

  const handleClick = (): void => {
    onClick()
    onDismissBanner()
  }

  if (!shouldShowCoachMark) {
    return <>{children}</>
  }

  return (
    <CoachMark onDismiss={onDismissBanner}>
      <CoachMark.Overlay>
        {children}
        <CoachMark.Spotlight size="small" />
      </CoachMark.Overlay>
      <CoachMark.Content side="bottom" align="start" showCloseIcon={false}>
        <CoachMark.Title>
          <NewBadge /> Posting Templates
        </CoachMark.Title>
        <CoachMark.Description>
          Browse a growing library of 80+ ready-made templates to spark ideas
          and create content with ease.
        </CoachMark.Description>
        <CoachMark.Footer>
          <CoachMark.Dismiss>
            <Button variant="tertiary">Not now</Button>
          </CoachMark.Dismiss>
          <Button variant="primary" onClick={handleClick}>
            Try it out
          </Button>
        </CoachMark.Footer>
      </CoachMark.Content>
    </CoachMark>
  )
}
